import axios from "../axios-auth";
import orginal_axios from "axios";

export const stockInService = {
    getStockInList,
    getAllStockInList,
    saveStockIn,
    getStockInDetail,
    saveStockInExcel,
    exportStockInExcel,
    getStockInExcelTemplate
};

function getStockInList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/stockins", { params });
}

function getAllStockInList(searchParams) {
    let params = {
        sort: "warehouseName,asc"
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/stockins", { params });
}

function saveStockIn(stockIn) {
    if (!stockIn.id) {
        // new stockin
        return axios.post("/auth/stockin", stockIn);
    } else {
        // edit
        return axios.put("/auth/stockin", stockIn);
    }
}

function getStockInDetail(id) {
    return axios.get("/auth/stockin/" + id);
}

function saveStockInExcel(file) {
    return axios.post('/auth/stockin-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function exportStockInExcel(searchParams) {
    let params = {
    };
    if (searchParams.warehouseId) {
        params["warehouseId"] = searchParams.warehouseId;
    }

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }

    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }

    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }

    if (searchParams.poNo) {
        params["poNo"] = searchParams.poNo;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stockin-excel",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getStockInExcelTemplate() {

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/stockin-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

